<div class="card mb-0 h-100">
    <div class="card-body h-100 p-0 d-flex align-items-stretch">
        <!-- <ng-container [ngSwitch]="apiType">
            <ng-container *ngSwitchCase="'dsdelivery'">
                대신택배
            </ng-container>
            <ng-container *ngSwitchCase="'smilk'">
                <dtg-car-ext-last-map class="h-100 flex-grow-1"></dtg-car-ext-last-map>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <dtg-car-last-list-map class="h-100 flex-grow-1"></dtg-car-last-list-map>
                <dtg-car-ext-last-map class="h-100 flex-grow-1"></dtg-car-ext-last-map>
            </ng-container>
        </ng-container> -->
        <dtg-car-last-list-map class="h-100 flex-grow-1"></dtg-car-last-list-map>
    </div>
</div>